export function replaceEquals(value) {
  if (typeof value === 'string') {
      return value
          .replace(/=/g, '&&EQUAL&&')
          .replace(/\?/g, '&&QUESTION&&')
          .replace(/'/g, '&&SINGLEQUOTE&&')
          .replace(/,/g, '&&COMMA&&')
          .replace(/\./g, '&&DOT&&')
          .replace(/"/g, '&&DOUBLEQUOTE&&')
          .replace(/\+/g, '&&PLUS&&')
          .replace(/\//g, '&&SLASH&&');
  }
  return value;
}

export function restoreEquals(value) {
  if (typeof value === 'string') {
      return value
          .replace(/&&EQUAL&&/g, '=')
          .replace(/&&QUESTION&&/g, '?')
          .replace(/&&SINGLEQUOTE&&/g, "'")
          .replace(/&&COMMA&&/g, ',')
          .replace(/&&DOT&&/g, '.')
          .replace(/&&DOUBLEQUOTE&&/g, '"')
          .replace(/&&PLUS&&/g, '+')
          .replace(/&&SLASH&&/g, '/');
  }
  return value;
}
